// extracted by mini-css-extract-plugin
module.exports = {"intents":"CallIntents_intents__13SR9","callerInformation":"CallIntents_callerInformation__zWXqR","callerIntents":"CallIntents_callerIntents__3Wvi6"};